export default class YandexMetrika {
    static reachGoal(target, params) {
        const counterId = BX.message('CITRUS_CORE_YANDEX_COUNTER_ID');
        if (!counterId) {
            console.warn('No CITRUS_CORE_YANDEX_COUNTER_ID defined in BX.message()');
            return;
        }

        params = params || {};
        params.url = window.location.href;

        ym(counterId, 'reachGoal', target, params);

        console.info(`reachGoal: ${target}`, params);
    }

    static ready() {
        const $body = $('body');

        $body.on('click', 'a[href^="tel:"]', e => YandexMetrika.reachGoal('phone_number', {
            phone: e.currentTarget.href.replace(/^tel:/, ''),
        }));
        $body.on('click', 'a[href^="mailto:"]', e => YandexMetrika.reachGoal('e_mail', {
            email: e.currentTarget.href.replace(/^mailto:/, ''),
        }));

        $body.on('click', '.footer-social-list > a', (e) => {
            const link = $(e.currentTarget);
            const classToGoalMap = {
                vk: 'klik_VK',
                fb: 'klik_FB',
                tw: 'klik_TW',
                ig: 'klik_IG',
                yb: 'klik_Youtube',
                ok: 'klik_OK',
            };

            Object.entries(classToGoalMap).forEach(([className, goal]) => {
                if (link.hasClass(className)) {
                    YandexMetrika.reachGoal(goal);
                }
            });
        });

        $body.on('click', '.add2favourites[data-id]:not(.added)', (e) => YandexMetrika.reachGoal('favorites', {
            object_id: e.currentTarget.dataset.id,
        }));

        // цели показа форм в попапах (ключи — ID формы, значения — ID цели)
        const formPopupShowGoals = new Map([
            ['header_order_call_form', 'order_call_header'],        // Заказ звонка в шапке #1
            ['arealty_icalculator', 'ipoteka'],                     // Расчет ипотеки #2
            ['arealty_pdf', 'send_e_mail'],                         // Отправка презентации #3
            ['68fe236acbcb7d2e4034a68d2fc9bc78', 'ask_question'],   // Задать вопрос #4
            ['qwe123', 'request_form'],                             // Отправить заявку #5
            ['citrus_realty_request_shedule', 'make_appointment'],  // Записаться на просмотр #6
            ['18fe2018cbcb7d8e4034a68d2fc9bc75', 'add_review'],     // Добавить отзыв #7
        ]);

        // заполнение форм в попапах
        const formPopupFillGoals = new Map(
            [...formPopupShowGoals].map(([formId, goalId]) => [formId, goalId + '_done'])
        );

        // полный список целей заполнения форм
        const formFillGoals = new Map(
            [...formPopupFillGoals].concat([
                // формы без попапа
                ['sect_block_form_review', 'add_review_on_page'],         // Добавить отзыв #8
                ['68fe236acbcb7d2e4034a68d2fc9bc76', 'contact_us'],       // Написать нам #9
                ['order_call_form', 'order_call_form'],                   // Заказ звонка #10
                ['68fe236acbcb7d2e4034a68d2fc9bc75', 'get_consultation_done'], // Помощь специалиста #11
            ])
        );

        const mapFormsToGoals = (goalsMap) => {
            return (e, { formId, form }) => {
                if (goalsMap.has(formId)) {
                    YandexMetrika.reachGoal(goalsMap.get(formId));
                } else {
                    console.warn('No goal for form', { target: e.currentTarget, formId, form })
                }
            };
        };

        $body.on('citrus-forms-show', 'form', mapFormsToGoals(formPopupShowGoals));
        $body.on('citrus-forms-success', 'form', mapFormsToGoals(formFillGoals));

        $(() => {
            $('.js_link_form_review').on('click', () => YandexMetrika.reachGoal('add_review'));
        });
    }
};

BX.namespace('Citrus.Core.YandexMetrika');
BX.Citrus.Core.YandexMetrika = YandexMetrika;

$(YandexMetrika.ready);
